import { Router } from 'pages/router'
import { SupportedBrowsersGate } from 'pages/supported-browsers-gate'
import ReactDOM from 'react-dom/client'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { SoundProvider } from 'features/sound/sound-context'

import { TooltipProvider } from 'shared/components/ui/tooltip'

import './index.css'
import reportWebVitals from './reportWebVitals'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <TooltipProvider>
    <ToastContainer autoClose={3000} theme="light" />
    <SupportedBrowsersGate>
      <SoundProvider>
        <Router />
      </SoundProvider>
    </SupportedBrowsersGate>
  </TooltipProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
